import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink} from 'reactstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faHome, faVideo, faInfoCircle, faPhoneAlt, faEnvelope } from '@fortawesome/free-solid-svg-icons'
import '../scss/NavMenu.css';
import { toJS } from 'mobx';

export class NavMenu extends Component {

  constructor (props) {
    super(props);

    this.state = {
      collapsed: true,
      headerClass: 'navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3',
      skrunk: false
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.resizeHeaderOnScroll);
  }
  componentWillUnmount(){
    window.removeEventListener('scroll', this.resizeHeaderOnScroll);
  }
  resizeHeaderOnScroll = () => {
    const distanceY = window.pageYOffset || document.documentElement.scrollTop
    const shrinkOn = 100;

    if (distanceY > shrinkOn) {
        this.setState({
            headerClass: 'navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3 shrink',
            skrunk: true
        })
    }
    else if (this.state.skrunk) {
        this.setState({
            headerClass: 'navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3',
            skrunk: false
        })
    }
  }

  toggleNavbar = () => {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  closeNavbar = () => {
    if (!this.setState.collapsed) {
        this.setState({collapsed: true});
    }
  }

  render () {
    return (
      <header>
        <Navbar className={this.state.headerClass} light fixed="top" style={{backgroundColor: "#FFF"}}>
            <Container>
                <NavbarBrand tag={Link} to="/"><img alt="Palm Island Specialist" src={`${process.env.PUBLIC_URL}/images/logo.png?w=220`} className="img-fluid logo" /></NavbarBrand>
                <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
                <Collapse className="d-sm-inline-flex flex-sm-row" isOpen={!this.state.collapsed} navbar>
                    <div style={{margin: '0 auto'}}>
                        <ul className="navbar-nav flex-grow">
                            <NavItem>
                                <NavLink onClick={this.closeNavbar} tag={Link} className="text-dark my-2 mr-2" to="/search"><FontAwesomeIcon icon={faSearch} size="lg"/> Search</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink onClick={this.closeNavbar} tag={Link} className="text-dark my-2 mr-2" to="/listings"><FontAwesomeIcon icon={faHome} size="lg"/> Specialist Listings</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink onClick={this.closeNavbar} tag={Link} className="text-dark my-2 mr-2" to="/videos"><FontAwesomeIcon icon={faVideo} size="lg"/> Island Media</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink onClick={this.closeNavbar} tag={Link} className="text-dark my-2" to="/aboutus"><FontAwesomeIcon icon={faInfoCircle} size="lg"/> About Us</NavLink>
                            </NavItem>
                        </ul>
                    </div>
                </Collapse>
            </Container>

            <div className="sub-menu mr-2 text-nowrap text-dark">
                <div><Link to="/email"><FontAwesomeIcon icon={faEnvelope}/> Send Email</Link></div>
                <div><a href="tel:941-769-0198"><FontAwesomeIcon icon={faPhoneAlt}/> 941 769 0198</a></div>
            </div>

        </Navbar>

      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NavMenu.jsx